// Thin fetch wrapper for the Netlify function at /api/*.

export class ApiError extends Error {
  constructor(status, message, body = {}) {
    super(message);
    this.status = status;
    this.body = body;
  }
}

async function request(method, path, data) {
  const isForm = data instanceof FormData;
  const res = await fetch(`/api/${path}`, {
    method,
    credentials: 'same-origin',
    headers: data && !isForm ? { 'Content-Type': 'application/json' } : undefined,
    body: data ? (isForm ? data : JSON.stringify(data)) : undefined,
  });
  let body = {};
  try {
    body = await res.json();
  } catch {
    // non-JSON (e.g. a gateway error page)
  }
  if (!res.ok) throw new ApiError(res.status, body.error || `Request failed (${res.status})`, body);
  return body;
}

export const api = {
  get: path => request('GET', path),
  post: (path, data) => request('POST', path, data ?? {}),
  put: (path, data) => request('PUT', path, data ?? {}),
  patch: (path, data) => request('PATCH', path, data ?? {}),
  del: path => request('DELETE', path),
  upload: file => {
    const form = new FormData();
    form.append('file', file);
    return request('POST', 'admin/upload', form);
  },
};
